export default  {
    floorplan: '',
    sqft: '',
    start_date:'',
    beds: '',
    full_baths: '',
    stories: '',
    garage: '',
    half_baths: '',
    elevation: '',
}